// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.0.1",
  date: "2026-06-08T08:17:07.722Z",
  gitInfo: {
    dirty: false,
    raw: "1bd3e85db",
    hash: "1bd3e85db",
    distance: null,
    tag: null,
    semver: null,
    suffix: "1bd3e85db",
    semverString: null
  }
};
/* tslint:enable */
